import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box';
import Slider, { SliderThumb } from '@mui/material/Slider';

import styles from '../../Css/CustomSettings.module.css'
import Styles from '../../Css/UploadScreen.module.css'

import { styled } from '@mui/material/styles';
export default function CarPostProcessingBrightness(props) {
    const [brightness, setBrightness] = useState(50);

    const brightnessLevels = [
        {
          value: 33,
        },
        {
          value: 66,
        },
        // {
        //   value: 99,
        // },
      ];
      

      function valuetext(value) {
        setBrightness(value)
        return props.handleBrightness(value)
      }

      function valueLabelFormat(value){
        if (value < 33) {
            return "Light"
        }
        else if (value < 66) {
            return "Normal"
        }
        else{
            return "Dark"
        }
          
      }

      function img() {
        if (brightness < 33) {
            return <img src="https://storage.googleapis.com/spyne-website/static/landing-page/homepage/0%20tint%20(1).png"></img>
        }
        else if (brightness < 66) {
            return <img src="https://storage.googleapis.com/spyne-website/static/landing-page/homepage/Light%20Tint%20(1).png"></img>
        }
        else{
            return <img src="https://storage.googleapis.com/spyne-website/static/landing-page/homepage/Dark%20Tint.png"></img>
        }
      }

    return (
        <div>
            <div className="row py-4">
                <h6 className="col-6">Brightness</h6>
                <Box sx={{ width: '100%' }}>
                    <Slider
                        aria-label="Custom marks"
                        defaultValue={50}
                        getAriaValueText={valuetext}
                        step={33}
                        valueLabelDisplay="auto"
                        marks={brightnessLevels}
                        valueLabelFormat={valueLabelFormat}
                        
                    />
                </Box>
           
            </div>

        </div>
    )
}
